module.exports = __webpack_public_path__ + "img/SketchPngd438dfdaa8969be7cb70d8261772d5d518207f89c34f26f6f4ce904d92f83d59.d3f772b4.png";